import cx from 'classnames';
import { Component, h } from 'preact';

type Props = {
  children?: any;
};

type State = {
  isExpanded: boolean;
};

class DistrictInfo extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isExpanded: true };
  }

  toggle = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  render() {
    const { children } = this.props;
    const { isExpanded } = this.state;

    return (
      <div class="district-info">
        <button
          type="button"
          class={cx('district-info__toggle', { 'is-expanded': isExpanded })}
          onClick={this.toggle}
          aria-expanded={String(isExpanded)}
        >
          <h4 class="district-grid__title">About this district</h4>
          <svg
            class="district-info__chevron"
            viewBox="0 0 12 8"
            aria-hidden="true"
          >
            <path
              d="M1 1l5 5 5-5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </button>
        {isExpanded && <div class="district-grid">{children}</div>}
      </div>
    );
  }
}

export default DistrictInfo;
